var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefaultPolicy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 39,
    viewBox: "0 0 32 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8997 31.2406L10.8997 26.9406C9.59971 25.8406 8.79971 24.2406 8.59971 22.4406L8.19971 18.3406H8.79971L11.0997 17.5406C12.0997 17.2406 12.9997 16.7406 13.7997 16.2406L15.9997 14.8406L17.9997 16.3406C18.6997 16.8406 19.4997 17.3406 20.3997 17.7406L23.7997 19.2406L23.4997 22.4406C23.2997 24.2406 22.4997 25.8406 21.0997 26.9406L15.8997 31.2406ZM9.59971 19.4406L9.89971 22.3406C9.99971 23.7406 10.6997 25.0406 11.7997 26.0406L15.9997 29.6406L20.1997 26.0406C21.2997 25.1406 21.9997 23.8406 22.0997 22.3406L22.2997 20.0406L19.7997 18.8406C18.8997 18.4406 17.9997 17.9406 17.1997 17.3406L15.8997 16.3406L14.4997 17.2406C13.5997 17.8406 12.5997 18.3406 11.4997 18.7406L9.59971 19.4406Z",
    fill: "#24293D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6995 20.4406L15.3995 25.6406L12.4995 22.6406H13.9995L15.3995 24.0406L19.0995 20.4406H20.6995Z",
    fill: "#24293D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.49971 34.0405H0.199707V0.0405273H21.7997L31.7997 10.2405V24.5405H30.5997V10.7405L21.1997 1.24053H1.49971V34.0405Z",
    fill: "#24293D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7997 38.4406H0.199707V32.2406H1.49971V37.2406H30.5997V26.9406H31.7997V38.4406Z",
    fill: "#24293D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1999 11.3405H20.8999V0.640503H22.0999V10.1405H31.1999V11.3405Z",
    fill: "#24293D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultPolicy);
export default __webpack_public_path__ + "static/media/defaultPolicy.90635c00723e4db2c89bade0f217efe2.svg";
export { ForwardRef as ReactComponent };